import type {
  PushNotificationDeviceUpdateRequestType,
  PushNotificationDeviceUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePushNotificationDeviceUpdate = (deviceId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PushNotificationDeviceUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `push-notification/devices/${deviceId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as PushNotificationDeviceUpdateResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.NotificationToken],
      });
    },
  });
};
